import { useEffect } from 'react';
import { enableDevMode, disableDevMode } from '@/features/devModeSlice';
import { useAppDispatch } from '@/app/hooks';
import { useUserClientContext } from '@/app/clientContext';

/** A component to set the devMode flag state in redux */
export const DevModeDetector = (): null => {
  const dispatch = useAppDispatch();
  const { isInternalUser } = useUserClientContext();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const devModeParam = searchParams.get('devmode');
    if (isInternalUser) {
      if (devModeParam === 'true') {
        dispatch(enableDevMode());
      } else if (devModeParam === 'false') {
        dispatch(disableDevMode());
      } else {
        const savedDevMode = sessionStorage.getItem('devMode');
        if (savedDevMode === 'true') {
          dispatch(enableDevMode());
        }
      }
    }
  });

  // This component renders nothing
  return null;
};
